// extracted by mini-css-extract-plugin
export default {"container":"Contato_container__oUqjb","photoSection":"Contato_photoSection__ukFec","photo":"Contato_photo__l5yGy","infoSection":"Contato_infoSection__BUBFP"};